import React, { useEffect, useState } from "react";
import TextEditor from "../Common/textEditor";
import Drawer from 'react-modern-drawer';
import GenerationAllServices from "./generationAllServices";
import Pagination from 'components/Common/newPagination';

export default function EmailTemplate(param: any) {

    let [emailTempList, initEmailTemplist] = useState<any>([]);
    let [emailTempTotalRow, initEmailTempTotalRow] = useState(0);

    const EmailTemplateClose = () => { param?.EmailTemplateClose() }

    var payload = { pageNumber: 1, pageSize: 10 }

    useEffect(() => {
        apiCall();
    }, []);

    const apiCall = () => {
        GenerationAllServices.emailTemplateList(payload).then((res: any) => {
            initEmailTemplist(res)
            emailTempTotalRow = res && res[0] && res[0]?.totalRows ? res[0].totalRows : 0
            initEmailTempTotalRow(emailTempTotalRow)
        })
    }

    const selectTemplateListing = (template: any) => {
        param?.EmailTemplateClose(template)
    }

    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        apiCall();
    }

    return (

        <>
            <Drawer open={param.openEmailTemplate} onClose={() => EmailTemplateClose()} direction={"right"} className='react-drawer allowHscroll allowVscroll'>
                <div className="ws-6 box landing allowHscroll allowVscroll">
                    <div className="box ws-12 pull-left">

                        <div className="box-header-main">
                            <h2 className="ws-6"><strong>Email Templates</strong></h2>
                        </div>

                        <div className="box">

                            <div className="box-content pLarge allowVscroll allowHscroll">
                                <h3 className="pull-left capitalize pt pb">  Search results: {emailTempTotalRow}</h3>

                                <table className="newTable">

                                    <thead>
                                        <tr>
                                            <th> Attachment</th>
                                            <th> Message </th>
                                            <th> Signature</th>
                                            <th> Subject</th>
                                            <th> Operation</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            emailTempList?.map((emailTempVal: any) => {
                                                return (<>
                                                    <tr>
                                                        <td ><div dangerouslySetInnerHTML={{ __html: emailTempVal?.attachment || "" }} /> </td>
                                                        <td ><div dangerouslySetInnerHTML={{ __html: emailTempVal?.message || "" }} /></td>
                                                        <td ><div dangerouslySetInnerHTML={{ __html: emailTempVal?.signature || "" }} /></td>
                                                        <td ><div dangerouslySetInnerHTML={{ __html: emailTempVal?.subject || "" }} /></td>
                                                        <td ><button className="icon-btn edit width70 height35" onClick={() => selectTemplateListing(emailTempVal)}>Select</button> </td>
                                                    </tr>
                                                </>)
                                            })
                                        }

                                    </tbody>

                                </table>

                                <div className="clearfix">
                                </div>

                            </div>
                        </div>

                        <div className="box footer pm noBorderRadius">
                            <button className="icon-btn delete pull-right" onClick={() => EmailTemplateClose()}>
                                Close
                            </button>
                        </div>

                    </div>

                    {(() => {
                        if (emailTempTotalRow && emailTempTotalRow > 10) {
                            return <Pagination onPageChange={handleNameOnChange} totalRow={emailTempTotalRow} />;
                        }

                    })()}
                </div>

            </Drawer>
        </>
    )

}